import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { InputComponentProps } from "components/Form/components/InputComponentProps";
import { Icon, IconLike } from "components/Icon/Icon";
import styles from "./Toggle.module.scss";

export type ToggleProps<T> = {
    identifier: string;
    value: T;
    input?: InputComponentProps<T>;
    attributes?: any; // TODO consider improvement
    options: { label: string; value: T; icon?: IconLike }[];
    onChange?: (e, value: T) => void;
};

export const Toggle = ({
    identifier,
    value,
    input,
    attributes,
    options,
    onChange,
}: ToggleProps<string | number | boolean>) => {
    return (
        <div className={styles.toggleComponent}>
            <ToggleButtonGroup
                {...input}
                {...attributes}
                value={value}
                onChange={onChange}
                exclusive
                aria-label={identifier}
            >
                {options.map((option) => (
                    <ToggleButton value={option.value} key={option.label}>
                        {option.icon ? <Icon className="button__icon" icon={option.icon} /> : null}
                        {option.label}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
        </div>
    );
};
